// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB97KbJQbHTlUOqdPnN2Y6WLmqiSYt81jU",
    authDomain: "dcsptest-sso.service.deloitte.ai",
    projectId: "dcsptest",
  },
  authParams: ["oidc.azure"],
  signInType: "signInWithPopup",
  subscriptionServiceBaseURL: "https://dcsp.api-dev.deloitte.camp",
  chatBackendBaseURL: "https://dcsp-estimate.connect-dev.api.deloitte.ai",
  product_id: "prd_5fbb8e9a-f694-4703-b6dc-54a9fcb24341",
  aoh_url: "",
  store_url: "",
  products: {
    estimate: true,
  },
  onboarding: {
    displayVideo: false,
    video_url: "",
    development: {
      frontend_url: "",
      backend_url: "",
      business_support_email: "",
    },
  },
  assetTitle: "Estimate",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
